import React, { useEffect, useState } from "react";
// import "./Category.css";

import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { getProductCategoryByCategoryIdAPI } from "../../../../Store/Action/productCategory";
import CategoryCard from "../../CustomComponents/CategoryCard";
import CustomLoader from "../../CustomComponents/CustomLoader/CustomLoader";

// Reusable for both "Shop by Gold" and "Shop by Silver" sections —
// same category-tile shape as ShopByCategory (product_category_id, product_category_name, product_category_storage_url)
const ShopByMetalCategory = ({
  data,
  title,
  subtitle,
  viewAllPath,
  metalName,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [categoryData, setCategoryData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (data) {
      setCategoryData(data);
      setIsLoading(false);
    }
  }, [data]);

  const handleIndividualCategory = async (category) => {
    setIsLoading(true);
    try {
      await dispatch(
        getProductCategoryByCategoryIdAPI(
          category?.product_category_id,
          (result) => {
            const fetchedData = result?.data[0];
            const subCategories = fetchedData?.product_sub_categories || [];

            if (subCategories.length > 0) {
              navigate("/sub-categories", {
                state: { subCategories, fromHomePageCategory: true },
              });
            } else {
              navigate(`/productsList/${category?.product_category_id}`, {
                state: {
                  subCategoryId: fetchedData?.product_category_id,
                  subCategoryName: fetchedData?.product_category_name,
                },
              });
            }
          },
        ),
      );
    } catch (error) {
      console.log("Error fetching subcategories:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleViewAllClickFunc = () => {
    navigate("/shop-by-category", {
      state: {
        fromShopByMetal: true,
        metalName,
        categoriesData: categoryData,
      },
    });
  };

  return (
    <div className="shopByCategoryDiv">
      <div className="upperContent">
        <h1>{title}</h1>
        <p>{subtitle}</p>
      </div>
      <div className="lowerContent">
        <div className="hrLine" />
        <div className="view-all">
          <p onClick={handleViewAllClickFunc}>View all</p>
        </div>
        {isLoading ? (
          <div className="loaderContainer">
            <CustomLoader />
          </div>
        ) : categoryData?.length > 0 ? (
          <div className="cardsContainer">
            {categoryData.map((category, index) => (
              <CategoryCard
                key={index}
                item={{
                  image: category?.product_category_storage_url,
                  name: category.product_category_name,
                }}
                onClick={() => handleIndividualCategory(category)}
              />
            ))}
          </div>
        ) : (
          <p className="no-data-text">No {metalName} categories available</p>
        )}
      </div>
    </div>
  );
};

export default ShopByMetalCategory;
